import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import RfPageFrame from '../layout/RfPageFrame';

export default function SolutionsGovernance() {
  return (
    <>
      <div className="rf-hero-band">
        <RfPageFrame className="!py-10 md:!py-14">
          <p className="text-xs font-medium uppercase tracking-[0.12em] text-[#5c6d7e] mb-2">Solutions · Governance</p>
          <h1 className="text-2xl md:text-[1.85rem] font-semibold text-[#2c2c2c] tracking-tight max-w-3xl">
            Policy, oversight, and evidence for AI
          </h1>
          <p className="mt-4 text-[#5c5c5c] max-w-2xl leading-relaxed">
            Governance is where technical signals meet organisational rules. This line pairs AI governance workflows with
            structured cybersecurity assessment—so committees see a coherent story.
          </p>
        </RfPageFrame>
      </div>

      <section className="bg-[#f0f7ff] border-b border-[#e5eef6]">
        <RfPageFrame className="py-16">
          <div className="grid md:grid-cols-2 gap-6">
            <article className="rf-card p-6 md:p-8 flex flex-col bg-white">
              <h2 className="text-lg font-semibold text-[#2c2c2c] mb-2">AI governance</h2>
              <p className="text-[0.9375rem] text-[#5c5c5c] leading-relaxed flex-1 mb-5">
                Ownership, review gates, and audit trails that stay understandable outside engineering—via our AiGov
                solution direction.
              </p>
              <Link to="/aigov" className="inline-flex items-center gap-1.5 text-[0.9375rem] font-medium text-[#005a9c]">
                Open AiGov <ArrowRight className="w-4 h-4" />
              </Link>
            </article>
            <article className="rf-card p-6 md:p-8 flex flex-col bg-white">
              <h2 className="text-lg font-semibold text-[#2c2c2c] mb-2">Cybersecurity assessment</h2>
              <p className="text-[0.9375rem] text-[#5c5c5c] leading-relaxed flex-1 mb-5">
                Repeatable testing and reporting for AI systems—aligned to how security teams already run assessment
                programmes (delivered through ScanFort).
              </p>
              <Link to="/scanfort" className="inline-flex items-center gap-1.5 text-[0.9375rem] font-medium text-[#005a9c]">
                Open ScanFort <ArrowRight className="w-4 h-4" />
              </Link>
            </article>
          </div>

          <p className="mt-10 text-[0.9375rem] text-[#5c5c5c]">
            <Link to="/solutions/ai-security" className="text-[#005a9c] font-medium hover:text-[#004a82]">
              ← Solutions overview
            </Link>
          </p>
        </RfPageFrame>
      </section>
    </>
  );
}
